export const STATUS_STYLES = {
  "To Do": "bg-slate-100 text-slate-600 border-slate-200",
  "In Progress": "bg-[#F7FEE7] text-[#4D7C0F] border-[#D9F99D]",
  Review: "bg-[#FEF9C3] text-[#A16207] border-[#FEF08A]",
  Done: "bg-[#ECFDF5] text-[#047857] border-[#A7F3D0]",

  "Not Submitted": "bg-slate-100 text-slate-600 border-slate-200",
  "Pending Approval": "bg-[#FEF9C3] text-[#A16207] border-[#FEF08A]",
  Approved: "bg-[#ECFDF5] text-[#047857] border-[#A7F3D0]",
  Rejected: "bg-red-50 text-red-700 border-red-200",

  Draft: "bg-slate-100 text-slate-600 border-slate-200",
  Sent: "bg-[#F7FEE7] text-[#4D7C0F] border-[#D9F99D]",
  Paid: "bg-[#ECFDF5] text-[#047857] border-[#A7F3D0]",
  Overdue: "bg-red-50 text-red-700 border-red-200",

  Onboarding: "bg-[#FEF9C3] text-[#A16207] border-[#FEF08A]",
  Active: "bg-[#F7FEE7] text-[#4D7C0F] border-[#D9F99D]",
  Completed: "bg-slate-100 text-slate-600 border-slate-200",

  High: "bg-red-50 text-red-700 border-red-200",
  Medium: "bg-[#FEF9C3] text-[#A16207] border-[#FEF08A]",
  Low: "bg-slate-100 text-slate-600 border-slate-200",

  Pending: "bg-[#FEF9C3] text-[#A16207] border-[#FEF08A]",

  "Checked In": "bg-[#F7FEE7] text-[#4D7C0F] border-[#D9F99D]",
  "On Break": "bg-[#FEF9C3] text-[#A16207] border-[#FEF08A]",
  "Checked Out": "bg-[#ECFDF5] text-[#047857] border-[#A7F3D0]",
  "Auto-Closed": "bg-red-50 text-red-700 border-red-200",
};

export function statusClasses(value) {
  return STATUS_STYLES[value] || "bg-slate-100 text-slate-600 border-slate-200";
}
